import React from 'react'
import AiHero from '../../Components/Automation/AiHero'
import TechServicesSection from '../../Components/Automation/TechServicesSection'
import { ArrowRight } from 'lucide-react'
import CloudEngSection from '../../Components/Automation/CloudEngSection';
import CloudSolutionsSlider from '../../Components/slider/CloudSolutionsSlider';
import Banner from '../../Components/Banner';
import { Helmet } from 'react-helmet-async';
import ContactSection from '../../Components/home/ContactSection';
// --- DATA ---
const services = [
    {
        id: 1,
        title: "Cloud Services",
        category: "service",
        desc: "Elevate your applications with Mobikode’s cloud services designed for performance optimization, data protection and simplicity in migrations. We also cut costs so you can do more of what really matters!",
        defaultBg: "bg-gradient-to-b from-[#01386A] to-[#1C355E]", // Deep Blue Gradient
    },
    {
        id: 2,
        title: "Cloud Migration",
        category: "service",
        desc: "The future is now. Cloud is essential for organizations today to be more efficient and profitable. Mobikode can help you migrate your data into this new way of thinking by strengthening the core operations strategy and build a future-ready organization.",
        defaultBg: "bg-gradient-to-r from-[#01386A] to-[#4B6CB7]", // Blue to Royal Blue (Replaced Orange)
    },
    {
        id: 3,
        title: "DevOps Services",
        category: "service",
        desc: "We implement a continuous and data-driven approach to help you realize better outcomes with your infrastructure through the latest tech trends, tools, techniques – and even old-fashioned hard work!",
        defaultBg: "bg-gradient-to-br from-[#01386A] to-[#8E9EAB]", // Blue to Grayish Blue
    },
    {
        id: 4,
        title: "Cloud Services",
        category: "service",
        desc: "Elevate your applications with Mobikode’s cloud services designed for performance optimization, data protection and simplicity in migrations. We also cut costs so you can do more of what really matters!",
        defaultBg: "bg-gradient-to-b from-[#01386A] to-[#1C355E]", // Deep Blue Gradient
    },
    {
        id: 5,
        title: "Cloud Migration",
        category: "service",
        desc: "The future is now. Cloud is essential for organizations today to be more efficient and profitable. Mobikode can help you migrate your data into this new way of thinking by strengthening the core operations strategy and build a future-ready organization.",
        defaultBg: "bg-gradient-to-r from-[#01386A] to-[#4B6CB7]", // Blue to Royal Blue (Replaced Orange)
    },
    {
        id: 6,
        title: "DevOps Services",
        category: "service",
        desc: "We implement a continuous and data-driven approach to help you realize better outcomes with your infrastructure through the latest tech trends, tools, techniques – and even old-fashioned hard work!",
        defaultBg: "bg-gradient-to-br from-[#01386A] to-[#8E9EAB]", // Blue to Grayish Blue
    },
];

function CloudEngineering() {
    return (
        <div>
            <Helmet>
                <title>
                    Cloud Engineering Services | Cloud Migration & DevOps | Mobikode
                </title>

                <meta
                    name="description"
                    content="Mobikode provides cloud engineering services to help businesses build secure, scalable cloud environments, modernize infrastructure, migrate applications, and improve DevOps and operational efficiency."
                />

                <meta
                    name="keywords"
                    content="Cloud Engineering Services, Cloud Engineering Company, Cloud Services, Cloud Migration Services, Cloud Infrastructure Services, Cloud Modernization, DevOps Services, DevOps Consulting, CI CD Automation, Cloud Application Development, Cloud Optimization Services, Secure Cloud Solutions, Scalable Cloud Solutions, Enterprise Cloud Services"
                />

                <link
                    rel="canonical"
                    href="https://www.mobikode.com/capabilities/cloud-engineering"
                />

                <meta
                    property="og:title"
                    content="Cloud Engineering Services | Cloud Migration & DevOps | Mobikode"
                />

                <meta
                    property="og:description"
                    content="Build and modernize your cloud infrastructure with Mobikode's cloud engineering services. From cloud migration and optimization to DevOps and secure cloud solutions, we help businesses scale with confidence."
                />

                <meta
                    property="og:url"
                    content="https://www.mobikode.com/capabilities/cloud-engineering"
                />

                <meta
                    property="og:type"
                    content="website"
                />

                <meta
                    property="og:image"
                    content="https://www.mobikode.com/assets/service-detail/bg4.png"
                />

                <meta
                    name="twitter:card"
                    content="summary_large_image"
                />

                <meta
                    name="twitter:title"
                    content="Cloud Engineering Services | Cloud Migration & DevOps | Mobikode"
                />

                <meta
                    name="twitter:description"
                    content="Explore Mobikode's cloud engineering solutions for cloud migration, infrastructure optimization, DevOps, application modernization, security, and scalable cloud operations."
                />

                <meta
                    name="twitter:image"
                    content="https://www.mobikode.com/assets/service-detail/bg4.png"
                />
            </Helmet>
            <AiHero title="Cloud Engineering" text="Technology. Transformation. Trust." imgData="/assets/service-detail/bg4.png" />
            <CloudSolutionsSlider />
            
            <CloudEngSection />
            {/* <IndustriesWeServe />
            <WhyPartnerWithUs /> */}
            {/* <section className="relative w-full h-[400px] lg:h-[507px] flex items-center justify-center overflow-hidden">
                <div className="absolute inset-0 z-0">
                    <img
                        src="/assets/career/img12.png"
                        alt="Cloud Engineering Background"
                        className="w-full h-full object-cover"
                    />
                    <div className="absolute inset-0 bg-black/10"></div>
                </div>

                <div className="relative z-10 w-full max-w-[1440px] mx-auto px-[20px] lg:px-[80px] h-full flex items-center lg:items-center ">
                    <div className="bg-white p-8 lg:p-12 max-w-[588px] shadow-2xl rounded-sm">

                        <h2 className="text-[#01386A] text-[30px] lg:text-[40px] font-[600] font-sora leading-tight mb-6">
                            Cloud Engineering Services
                        </h2>

                        <p className="text-[#49577A] text-[16px] leading-[24px] font-graphik mb-8">
                         Speed up your digital growth with cloud solutions that are secure, scalable, and built to support your business as it evolves and grows naturally.
                        </p>

                        <a href="/contact" className="inline-flex items-center gap-2 text-[#01386A] underline font-graphik font-semibold text-lg hover:gap-3 transition-all duration-300 group">
                            Contact Now
                            <ArrowRight size={20} className="transition-transform group-hover:translate-x-1" />
                        </a>

                    </div>
                </div>
            </section> */}
            <br/>
            <br/>
            <br/>
            <Banner title="Cloud Engineering" text=" Empowering businesses with intelligent, autonomous AI solutions that drive efficiency and innovation." />
            <ContactSection/>
        </div>
    )
}

export default CloudEngineering
